import { createContext } from "react";
import type { TourContextValue } from "../types/tour.types";

export const TourContext = createContext<TourContextValue | null>(null);

export default TourContext;
